import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSkip5SecondsForward24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconSkip5SecondsForward24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.593 4.16a.75.75 0 1 0-1.06 1.061L10.312 7H6.75A3.75 3.75 0 0 0 3 10.75v5.5A3.75 3.75 0 0 0 6.75 20H11a.75.75 0 1 0 0-1.5H6.75a2.25 2.25 0 0 1-2.25-2.25v-5.5A2.25 2.25 0 0 1 6.75 8.5h3.562l-1.78 1.779a.75.75 0 0 0 1.061 1.06l3.06-3.059a.75.75 0 0 0 0-1.06zm8.494 10.326a1.42 1.42 0 0 0 1.413-1.419c.006-.857-.543-1.407-1.053-1.407a2.86 2.86 0 0 0-1.287.281 2 2 0 0 0-.348.223l-.005.005a.75.75 0 0 1-1.273-.538V7.288h3.995a.75.75 0 0 1 0 1.5h-2.495v1.589a4.5 4.5 0 0 1 1.413-.217c1.654 0 2.563 1.577 2.553 2.919a2.92 2.92 0 0 1-2.913 2.907 3.4 3.4 0 0 1-1.68-.46 3.6 3.6 0 0 1-.632-.46l-.013-.012-.004-.005-.002-.002h-.001v-.001l.53-.53-.531.53a.75.75 0 0 1 1.056-1.066l.01.01.062.052c.06.048.152.115.27.183.24.136.562.261.935.261"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSkip5SecondsForward24);
